import React from "react";
import {Label, ProgressBar} from "react-aria-components";
import "./TimerProgressBar.css"

function TimerProgressBar({progress, text,}: { progress: number, text?: string }) {

    return <div className="progress-bar">
        <ProgressBar value={progress}>
            {({percentage, valueText}) => <>
                <Label>{text}</Label>
                <span className="value">{valueText}</span>
                <div className="bar">
                    <div className="fill" style={{width: percentage + '%'}} />
                </div>
            </>}
        </ProgressBar>
    </div>
}

export default TimerProgressBar
